module.exports = __webpack_public_path__ + "2b2b5d542179175f51019d7a395f8187.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/printError.png
// module id = 270
// module chunks = 0